<template>

    <!-- new code -->
    <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
        <div class="wrapper contractor-content">
            <b-row justify="space-between" align-v="center">
                <b-col>
                    <div class="str-logo">
                        <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex" height="49px"/>
                    </div>
                </b-col>
                <b-col class="text-right">
                    <logout/>
                </b-col>
            </b-row>


            <div class="wrapper-main-content">
                <!-- sidebar -->
                <div class="sidebar">
                    <side-bar
                        :step="step"
                        :sidebarListLinks="sidebarListLinks"
                    ></side-bar>
                </div>
                <!-- sidebar  ends -->

                <!-- form -->
                <div class="main_content-form">
                    <div class="contractor-form-box p-4">
                        <slot></slot>
                    </div>
                </div>
                <!-- form ends  -->
            </div>

            <FooterComponent/>

        </div>
    </b-overlay>
</template>
<script>
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import Treeselect from "@riophae/vue-treeselect";
import SideBar from "../includes/SideBar.vue";
import Logout from "../../../../pages/common/Logout.vue";

export default {
    components: {
        Logout,
        FooterComponent,
        Treeselect,
        SideBar,
    },
    props: ["step"],
    data() {
        return {
            sidebarListLinks: [
                {label: 'Create Account', routeTo: {name: 'register-contractor', params: {step: 1}}, disabled: true},
                {label: 'Business Details', routeTo: {name: 'register-contractor', params: {step: 2}}, disabled: true},
                {label: 'Licence Check', routeTo: {name: 'register-contractor', params: {step: 3}}, disabled: true},
                {label: 'Insurance Check', routeTo: {name: 'register-contractor', params: {step: 4}}, disabled: true},
                {label: 'Declarations', routeTo: {name: 'register-contractor', params: {step: 5}}, disabled: true},
                {label: 'Submit', routeTo: {name: 'register-contractor', params: {step: 6}}, disabled: true},
            ]
        }
    }
}

</script>

